import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class FormattedCheckbox extends PureComponent {
  
  render() {
    const { checked, className, valid, disabled } = this.props
    return (
      <div
        className={`
          ${className} 
          ${!className.match(/mr-|mx-/) && 'mr-2'} 
          ${valid ? 'border-grey bg-white' : 'border-red bg-red-lightest'}
          rounded border min-w-6 h-6 items-center justify-center flex
          ${!disabled ? 'custom-radio' : ''}
        `}
      >
        {checked && (
          <svg className="fill-current h-4 w-4 text-harbor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
          </svg>
        )}
      </div>
    )
  }
}

FormattedCheckbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  valid: PropTypes.bool,
  disabled: PropTypes.bool
}

FormattedCheckbox.defaultProps = {
  checked: false,
  className: '',
  valid: true,
  disabled: false
}

export default FormattedCheckbox